import { motion } from 'framer-motion';
import type { Faction } from '../../types/kotch';
import { FACTION_INFO, FACTION_ABILITIES, getAllFactions } from '../../data/kotch/factionDecks';

interface FactionPickerProps {
  selectedFaction: Faction | null;
  onSelectFaction: (faction: Faction) => void;
  disabled?: boolean;
  label?: string;
}

export default function FactionPicker({
  selectedFaction,
  onSelectFaction,
  disabled = false,
  label = 'Choose Your Faction',
}: FactionPickerProps) {
  const factions = getAllFactions();

  return (
    <div className="kotch-faction-picker">
      <h4 className="kotch-faction-picker-label">{label}</h4>
      <div className="kotch-faction-grid">
        {factions.map(faction => {
          const info = FACTION_INFO[faction];
          const ability = FACTION_ABILITIES[faction];
          const isSelected = selectedFaction === faction;

          return (
            <motion.button
              key={faction}
              className={`kotch-faction-card ${isSelected ? 'selected' : ''}`}
              style={{
                '--faction-color': info.themeColor,
              } as React.CSSProperties}
              onClick={() => !disabled && onSelectFaction(faction)}
              disabled={disabled}
              whileHover={disabled ? {} : { scale: 1.03, y: -4 }}
              whileTap={disabled ? {} : { scale: 0.98 }}
            >
              <div
                className="kotch-faction-card-accent"
                style={{ backgroundColor: info.themeColor }}
              />
              <div className="kotch-faction-card-content">
                <span className="kotch-faction-name">{info.name}</span>
                <span className="kotch-faction-theme">{info.theme}</span>
                <span className="kotch-faction-desc">{info.description}</span>
                <div className="kotch-faction-ability">
                  <span className="kotch-faction-ability-name">{ability.name}</span>
                  <span className="kotch-faction-ability-desc">{ability.description}</span>
                </div>
              </div>
              {isSelected && (
                <motion.div
                  className="kotch-faction-selected-indicator"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  style={{ borderColor: info.themeColor }}
                />
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
